/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
	selector: 'app-tab',
	templateUrl: './tab.component.html'
})
export class TabComponent {
	@Input() tabTitle!: string;
	@Input() active = false;
	@Input() template!: TemplateRef<any>;
	@Input() idTab!: number;
}
